<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-form-field-wrapper
      [label]="'Typ'"
      [name]="'type'"
      [colSize]="4"
      [formField]="form.get('type')">
      <p-dropdown
        [options]="typeOptions"
        formControlName="type"
        id="type"
        class="p-input"></p-dropdown>
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'Name'"
      [name]="'name'"
      [colSize]="8"
      [formField]="form.get('name')">
      <input
        pInputText
        id="name"
        type="text"
        formControlName="name"
        class="p-input" />
    </app-form-field-wrapper>
  </div>
  <div class="grid" *ngIf="form.get('type')?.value !== 'Polygon'">
    <app-form-field-wrapper [colSize]="'fixed'" [hideLabel]="true">
      <p-colorPicker
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="form.value.color"
        (ngModelChange)="form.get('color')?.setValue($event)"></p-colorPicker>
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'Farbe'" [name]="'color'" [colSize]="2">
      <input
        formControlName="color"
        name="color"
        pInputText
        type="text"
        class="p-input" />
    </app-form-field-wrapper>
    <app-icon-dropdown
      [formField]="form.get('icon')"
      [colSize]="3"
      formControlName="icon"
      label="Icon"
      name="icon"></app-icon-dropdown>
    <app-tag-dropdown
      [colSize]="6"
      formControlName="tags"
      mode="all"></app-tag-dropdown>
  </div>
  <div class="grid">
    <app-form-field-wrapper [label]="'Quelle'" [name]="'geoSource'">
      <textarea
        rows="1"
        cols="30"
        pInputTextarea
        formControlName="geoSource"></textarea>
    </app-form-field-wrapper>
  </div>
  <div class="grid">
    <app-form-field-wrapper
      [colSize]="2"
      [label]="'Standard-Jahr'"
      [name]="'defaultLayer'"
      pTooltip="Jahr, das im Kommunal-Atlas standardmäßig geladen werden soll, sofern es Daten enthält."
      [formField]="form.get('defaultLayer')">
      <p-inputNumber
        id="defaultLayer"
        [useGrouping]="false"
        formControlName="defaultLayer"></p-inputNumber>
    </app-form-field-wrapper>
  </div>
  @if (!itemToEdit && allowInitialYears) {
    <h3><i class="fas fa-calendar-days"></i> Jahre hinzufügen</h3>

    <p-divider />
    <div
      class="flex align-items-center gap-3 grid"
      formArrayName="initialYears">
      @if (initialYearsFormArray && initialYearsFormArray.controls.length > 0) {
        <ng-container
          *ngFor="
            let yearControl of initialYearsFormArray.controls;
            let i = index
          "
          [formGroupName]="i">
          <app-form-field-wrapper
            styleClass="pt-0"
            [colSize]="2"
            [label]="'Jahr'"
            [name]="'year'"
            [formField]="yearControl.get('year')">
            <input formControlName="year" name="year" pInputText type="text" />
          </app-form-field-wrapper>
        </ng-container>
      }
      <p-button
        [text]="true"
        [raised]="true"
        [rounded]="true"
        pTooltip="Jahr hinzufügen"
        (click)="addYear()"
        icon="fas fa-circle-plus">
      </p-button>

      <p-button
        [text]="true"
        [raised]="true"
        [rounded]="true"
        severity="danger"
        pTooltip="Jahr löschen"
        [disabled]="initialYearsFormArray.length <= 1"
        (click)="removeYear(initialYearsFormArray.length - 1)"
        icon="fas fa-trash p-">
      </p-button>
    </div>
  }

  <p-divider />
  <div class="grid">
    <app-workspace-dropdown
      name="workspaces"
      type="dataLayerType"
      formControlName="workspaces"></app-workspace-dropdown>
  </div>
  <p-divider />

  <app-form-footer
    [hideCancelLink]="disableCancelLink"
    [cancelLevel]="2"
    [showRemoveButton]="!!itemToEdit"
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? removeDataLayerType(itemToEdit) : undefined
    "></app-form-footer>
</form>
